import React, { FunctionComponent } from 'react'
import { reactular } from '@vendhq/reactular'
import { SaleProductSearch } from '../product/SaleProductSearch'
import { useQuickKeysManager } from '../../ng-compat/hooks'
import { QuickKeys } from '../quick-keys/QuickKeys'
import { AddProductToSaleModals } from '../AddProductToSale/AddProductToSaleModals'

export const Workspace: FunctionComponent = () => {
  const quickKeysManager = useQuickKeysManager()
  const quickKeysEnabled = quickKeysManager.isQuickKeysEnabled()

  return (
    <>
      <div className="wr-global-search">
        <SaleProductSearch />
      </div>
      {quickKeysEnabled ? (
        <div className="wr-workspace-module-container">
          <QuickKeys />
        </div>
      ) : null}
      <AddProductToSaleModals />
    </>
  )
}

export const WorkSpaceComponent = reactular(Workspace, [], 'reactWrapper')
